import {
  parseSearchNumberValue,
  parseSearchStringValue,
  parseSearchArrayValue,
  parseSearchBooleanValue,
} from 'infrastructure/functions/parse-query-string';
import { useQueryFilterNew } from 'infrastructure/hooks/common/use-query-param-new';

import type { TParseFunctions } from 'infrastructure/hooks/common/use-query-param-new';
import type {
  IFollowUpTableDataFilters,
  INewlyTableDataFilters,
  IPartialsTableDataFilters,
  PodFilterValue,
} from 'infrastructure/interfaces';

const VALID_POD_FILTER_VALUES: ReadonlySet<string> = new Set([
  'primary',
  'secondary',
  'tertiary',
  'outside',
]);

const parsePodFilterValue = (
  value: string | null,
): PodFilterValue | undefined => {
  if (value && VALID_POD_FILTER_VALUES.has(value))
    return value as PodFilterValue;
  return undefined;
};

export type TCCMDataFilters = INewlyTableDataFilters &
  IFollowUpTableDataFilters &
  IPartialsTableDataFilters;

export const defaultCCMValues: TCCMDataFilters = {
  'n-page': 1,
  'n-excludeClinicGuid': [],
  'n-clinicGuid': [],
  'n-allExcluded': false,

  'f-page': 1,
  'f-excludeClinicGuid': [],
  'f-clinicGuid': [],
  'f-allExcluded': false,

  'p-page': 1,
  'p-excludeClinicGuid': [],
  'p-clinicGuid': [],
  'p-allExcluded': false,
};

const parseCCMFunctions: TParseFunctions<TCCMDataFilters> = {
  'n-page': parseSearchNumberValue,
  'n-name': parseSearchStringValue,
  'n-dueDate': parseSearchStringValue,
  'n-provider': parseSearchStringValue,
  'n-enrolledDate': parseSearchStringValue,
  'n-lastCallDate': parseSearchStringValue,
  'n-appointmentDate': parseSearchStringValue,
  'n-type': parseSearchStringValue,
  'n-clinicGuid': parseSearchArrayValue,
  'n-excludeClinicGuid': parseSearchArrayValue,
  'n-allExcluded': parseSearchBooleanValue,
  'n-numberOfCalls': parseSearchNumberValue,
  'n-calls': parseSearchStringValue,

  'f-page': parseSearchNumberValue,
  'f-name': parseSearchStringValue,
  'f-dueDate': parseSearchStringValue,
  'f-provider': parseSearchStringValue,
  'f-callsMonth': parseSearchStringValue,
  'f-lastBilledDate': parseSearchStringValue,
  'f-appointmentDate': parseSearchStringValue,
  'f-type': parseSearchStringValue,
  'f-clinicGuid': parseSearchArrayValue,
  'f-excludeClinicGuid': parseSearchArrayValue,
  'f-allExcluded': parseSearchBooleanValue,
  'f-numberOfCalls': parseSearchNumberValue,
  'f-actionTimes': parseSearchStringValue,
  'f-ccmInteractionStatus': parseSearchStringValue,
  'f-completed': parseSearchStringValue,

  'p-page': parseSearchNumberValue,
  'p-name': parseSearchStringValue,
  'p-dueDate': parseSearchStringValue,
  'p-provider': parseSearchStringValue,
  'p-callsMonth': parseSearchStringValue,
  'p-nextBillable': parseSearchStringValue,
  'p-appointmentDate': parseSearchStringValue,
  'p-minutes': parseSearchStringValue,
  'p-lastCallDate': parseSearchStringValue,
  'p-type': parseSearchStringValue,
  'p-clinicGuid': parseSearchArrayValue,
  'p-excludeClinicGuid': parseSearchArrayValue,
  'p-allExcluded': parseSearchBooleanValue,
  podFilter: parsePodFilterValue,

  patientGuid: parseSearchStringValue,
};

export const useCCMDataQueryFilter = () => {
  return useQueryFilterNew<TCCMDataFilters>(
    defaultCCMValues,
    parseCCMFunctions,
  );
};
